
import { registerBlockType } from '@quillforms/blocks';
import Element from './google-auto-complete';

registerBlockType('google-auto-complete', {
  supports: {
		editable: true,
		required: true,
		attachment: true,
		description: true,
		placeholder: true,
		defaultValue: true,
		logic: true,
		theme: true
	},
	attributes: {
    googleMapsApiKey: {
      type: 'string',
    },
    cityInput: {
      type: 'string',
    },
    stateInput: {
      type: 'string',
    },
    zipInput: {
      type: 'string',
    },
	},
	logicalOperators: [
		'is',
		'is_not',
		'starts_with',
		'contains',
		'ends_with',
		'not_contains'
	],

  display: (props) => <Element {...props} />
});

